import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper to format API error details
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

// Auth API calls
export const authAPI = {
  login: async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    return data;
  },

  register: async (userData) => {
    const { data } = await api.post('/api/auth/register', userData);
    return data;
  },

  logout: async () => {
    const { data } = await api.post('/api/auth/logout');
    return data;
  },

  getMe: async () => {
    const { data } = await api.get('/api/auth/me');
    return data;
  },

  refresh: async () => {
    const { data } = await api.post('/api/auth/refresh');
    return data;
  }
};

// Bookings API calls
export const bookingsAPI = {
  create: async (bookingData) => {
    const { data } = await api.post('/api/bookings', bookingData);
    return data;
  },

  getAll: async () => {
    const { data } = await api.get('/api/bookings');
    return data;
  },

  getDriverBookings: async (driverId) => {
    const { data } = await api.get(`/api/bookings/driver/${driverId}`);
    return data;
  },

  getById: async (bookingId) => {
    const { data } = await api.get(`/api/bookings/${bookingId}`);
    return data;
  },

  updateStatus: async (bookingId, status) => {
    const { data } = await api.patch(`/api/bookings/${bookingId}/status?status=${status}`);
    return data;
  },

  assignDriver: async (bookingId, driverId) => {
    const { data } = await api.patch(`/api/bookings/${bookingId}/assign?driver_id=${driverId}`);
    return data;
  }
};

// Reviews API calls
export const reviewsAPI = {
  create: async (reviewData) => {
    const { data } = await api.post('/api/reviews', reviewData);
    return data;
  },

  getAll: async () => {
    const { data } = await api.get('/api/reviews');
    return data;
  },

  getStats: async () => {
    const { data } = await api.get('/api/reviews/stats');
    return data;
  }
};

// Messages API calls
export const messagesAPI = {
  create: async (messageData) => {
    const { data } = await api.post('/api/messages', messageData);
    return data;
  },

  getBookingMessages: async (bookingId) => {
    const { data } = await api.get(`/api/messages/booking/${bookingId}`);
    return data;
  }
};

export default api;
